import { menu as types } from '../../constants/types'
export const setMenuTab = (routes, index) => (dispatch, getState) => {
    const { router: { location: { pathname } } } = getState()
    const matchedIndex = routes.findIndex(route => 
        route.path && route.path.toLowerCase() === pathname.toLowerCase()
    );

    dispatch({
        type: types.CHANGE,
        payload: matchedIndex >= 0 ? matchedIndex : (index ?? -1)
    });
}